// extracted by mini-css-extract-plugin
export var socialElement = "social-list-module--socialElement--9d9ab";